import api from '../services/api';

const SESSION_KEY = 'resunize_website_visit_recorded';

/** Count one visit per browser session when the landing page loads. */
export function recordWebsiteVisit() {
  try {
    if (typeof sessionStorage !== 'undefined' && sessionStorage.getItem(SESSION_KEY)) {
      return;
    }
    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.setItem(SESSION_KEY, '1');
    }
    api.post('/analytics/visit').catch(() => {});
  } catch {
    // Ignore storage / network errors — visit tracking is best-effort.
  }
}
